// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__nnVTC","options":"AnswerScale_options__3FANF","selected":"AnswerScale_selected__up0b3"};